import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card';
import { SectionType } from '@/domains/global-dashboard/utils/chart-utils';

export interface Section {
  type: SectionType;
  title: string;
  description: string;
}

export interface SummaryCard {
  title: string;
  currentValue: string;
  totalValue?: string | null;
  description?: string;
  currentValueTextColor: string;
}

export function DashboardSummarySection({
  section,
  summaryCards,
}: {
  section: Section;
  summaryCards: SummaryCard[];
}) {
  return (
    <>
      {/* Global Terminal Summary for Selected Markets for current month */}
      <Card>
        <CardHeader className="p-4 space-y-4">
          <div>
            <CardTitle className="text-base">{section.title}</CardTitle>
            <CardDescription>{section.description}</CardDescription>
          </div>
        </CardHeader>
        <CardContent className="p-4 pt-0">
          <div className="flex flex-wrap gap-4">
            {summaryCards.map((item) => (
              <Card key={item.title} className="flex-1">
                <CardHeader className="p-4 pb-0">
                  <p className="text-sm font-medium">{item.title}</p>
                </CardHeader>
                <CardContent className="p-4">
                  <div className="space-y-2">
                    <p className="text-2xl font-bold"> <span className={item.currentValueTextColor}>{item.currentValue}</span> {item.totalValue && <span>/ {item.totalValue}</span>}</p>
                    {item.description && <p className="text-xs">{item.description}</p>}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </CardContent>
      </Card>
    </>
  );
}
